import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import TextFieldTime from "../../UI/TextFieldTime";
import { minutos } from "./CronogramaAulaTable";

const isValido = (horario) => horario && dayjs(horario).isValid();

/** Diálogo de cadastro/edição de um horário de aula. */
export default function CronogramaAulaForm({ cronogramaAula, onClose, onSave, isSaving }) {
  const [valores, setValores] = useState({});

  useEffect(() => {
    if (!cronogramaAula) return;
    setValores({
      descricao: cronogramaAula.descricao ?? "",
      ordemAula: cronogramaAula.ordemAula ?? "",
      horarioInicio: cronogramaAula.horarioInicio ?? null,
      horarioFim: cronogramaAula.horarioFim ?? null,
    });
  }, [cronogramaAula]);

  const updateField = (name, value) => setValores((prevState) => ({ ...prevState, [name]: value }));

  const fimAntesDoInicio =
    isValido(valores.horarioInicio) &&
    isValido(valores.horarioFim) &&
    minutos(valores.horarioFim) <= minutos(valores.horarioInicio);
  const podeSalvar =
    Boolean(valores.descricao?.trim()) &&
    String(valores.ordemAula ?? "") !== "" &&
    isValido(valores.horarioInicio) &&
    isValido(valores.horarioFim) &&
    !fimAntesDoInicio &&
    !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...cronogramaAula, ...valores, ordemAula: Number(valores.ordemAula) });
  };

  return (
    <Dialog open={Boolean(cronogramaAula)} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{cronogramaAula?.codigo ? "Editar Horário de Aula" : "Novo Horário de Aula"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} pt={1}>
            <Grid size={{ xs: 12, sm: 8 }}>
              <TextField
                size="small"
                fullWidth
                required
                label="Descrição"
                placeholder="Ex.: 1ª aula - manhã"
                value={valores.descricao ?? ""}
                onChange={(event) => updateField("descricao", event.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                size="small"
                fullWidth
                required
                label="Ordem da aula"
                value={valores.ordemAula ?? ""}
                onChange={(event) => updateField("ordemAula", event.target.value.replace(/\D/g, "").slice(0, 2))}
                slotProps={{ htmlInput: { inputMode: "numeric" } }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextFieldTime
                label="Horário início"
                value={valores.horarioInicio}
                onChange={(value) => updateField("horarioInicio", value ? dayjs(value) : null)}
                slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextFieldTime
                label="Horário fim"
                value={valores.horarioFim}
                onChange={(value) => updateField("horarioFim", value ? dayjs(value) : null)}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    required: true,
                    error: fimAntesDoInicio,
                    helperText: fimAntesDoInicio ? "Deve ser depois do horário de início." : " ",
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
